import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/videos',
        component: () => import('@/pages/videos/VideoIndex.vue'),
        props: true,
        children: [
            {
                name: 'videos-index',
                path: '',
                component: () => import('@/components/videos/VideosView.vue'),
                meta: {
                    title: 'Videos',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'videos' },
                    dataTablePage: true,
                },
                props: true,
            },

            {
                name: 'videos-index-archive',
                path: '/videos/archive',
                component: () => import('@/components/videos/VideosView.vue'),
                meta: {
                    title: 'Archived Videos',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('archive a video'),
                    dataTablePage: true,
                },
                props: true,
            },
        ],
    },
    {
        path: '/videos/create',
        name: 'video-create',
        component: () => import('@/pages/videos/VideoCreate.vue'),
        meta: {
            title: 'Create Video',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'video' },
        },
        props: true,
    },
    {
        path: '/videos/:videoReferenceId',
        name: 'video-view',
        component: () => import('@/pages/videos/VideoView.vue'),
        meta: {
            title: 'Video',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'video' },
        },
        props: true,
    },
    {
        path: '/videos/:videoReferenceId/edit',
        name: 'video-edit',
        component: () => import('@/pages/videos/VideoEdit.vue'),
        meta: {
            title: 'Edit Video',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'video' },
        },
        props: true,
    },
];
